module.exports = __webpack_public_path__ + "img/flay.46a17718.png";